module.exports = __webpack_public_path__ + "img/naver.301bae43.png";